
import { ClientConstants } from '@/client.constants';
import { PvdLink, PvdPopover } from '@fmr-ap109253/apex-kit/dist/lib/src/pvd';
import { Component, Vue } from 'vue-property-decorator';

@Component
export default class LearnMorePopover extends Vue {
    heading = ClientConstants.LM_POPOVER_HEADING;
    bondYieldUrl = ClientConstants.LM_BOND_YIELD_URL;
    learningCenterUrl = ClientConstants.LM_LEARNING_CENTER_URL;
    yieldPriceCalcInfo = ClientConstants.FOOTNOTE_FOR_ANNUAL_COUPON_RATE

    setTarget(trigger: PvdLink) {
        (this.$refs['learn-more-popover'] as PvdPopover).pvdTarget = trigger;
    }

    openModal() {
        (this.$refs['learn-more-popover'] as PvdPopover).pvdOpen = true;
    }
}
